// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import FilePlayer from 'react-player/lib/players/FilePlayer'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'
import ImageOverlay from 'church-theme-library/components/Image/ImageOverlay'
import MediaPlayer from 'church-theme-library/components/MediaPlayer/MediaPlayer'

class Hero extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		if ( ! data ) {
			return null
		}

		const fullData = {
			image: data.image || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				copy_space: '',
				width: '',
				height: '',
				thumb: '',
				srcset: '',
				type: '',

				// Video:
				id: '',
				service: '',
				thumb_url: ''
			},
			title: data.title || '',
			button: data.button || {
				url: '',
				text: ''
			}
		}

		let copySpaceData = new Array( 3 )

		if ( fullData.image.copy_space && Object.keys( fullData.image.copy_space ).length ) {
			Object.keys( fullData.image.copy_space ).map( ( key, i ) => {
				copySpaceData[ i ] = fullData.image.copy_space[ key ]
			} )
		}

		return (
			<div className="section-hero"
				data-copy-space-0={ copySpaceData[0] }
				data-copy-space-1={ copySpaceData[1] }
				data-copy-space-2={ copySpaceData[2] }
				>
				<div className="-inner">
					<div className="-text">
						<div className="-inner">
							<Editable
								element="h2"
								id={ contentId }
								sectionId={ sectionId }
								sectionType="hero"
								sectionDataId="title"
								content={ fullData.title }
							/>

							<div className="buttons">
								<Editable
									id={ contentId }
									sectionId={ sectionId }
									sectionType="hero"
									sectionDataId="button"
								/>

								<a href={ fullData.button.url } className="button -ghost">{ fullData.button.text }</a>
							</div>
						</div>
					</div>

					<ImageOverlay imageData={ fullData.image } />

					<Editable
						id={ contentId }
						sectionId={ sectionId }
						sectionType="hero"
						sectionDataId="image"
						className="-image"
					>
						{ 'video' == fullData.image.type &&
							<div className="-video">
								<FilePlayer
									playing={ true }
									url={ fullData.image.url }
									loop={ true }
									controls={ false }
									muted={ true }
									volume={ 0 }
								/>
							</div>
						|| 'external_video' == fullData.image.type &&
							<div className="-video">
								<MediaPlayer
									key={ fullData.image.id }
									id={ fullData.image.id }
									service={ fullData.image.service }
									url={ fullData.image.url }
									thumb_url={ fullData.image.thumb_url }
									playing={ true }
									loop={ true }
									controls={ false }
									muted={ true }
									volume={ 0 }
								/>
							</div>
						||
							<Image
								thumb={ fullData.image.thumb }
								url={ fullData.image.url }
								srcset={ fullData.image.srcset }
								srcsetWebp={ fullData.image.srcset_webp }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
								alt={ fullData.image.alt }
								focalPoint={ fullData.image.focal_point }
								width={ fullData.image.width }
								height={ fullData.image.height }
								downloadFullImage={ true }
							/>
						}
					</Editable>
				</div>
			</div>
		)
	}
}

export default Hero
